import { useState } from 'react'
import Treemap from '../../components/layout/Treemap'
import AchievementPage from './AchievementPage'
import AthleteProfile from './AthleteProfile'
import AnalysisPage from './AnalysisPage'
import SessionInput from './SessionInput'
import NotificationBell from '../../components/shared/NotificationBell'
import { supabase } from '../../lib/supabase'

export default function AthleteDashboard({ profile }) {
  const [page, setPage] = useState('dashboard')
  const [athleteId, setAthleteId] = useState(null)

  // Ambil athlete id saat pertama load
  useState(() => {
    const fetchAthleteId = async () => {
      const { data } = await supabase
        .from('athletes')
        .select('id')
        .eq('profile_id', profile.id)
        .single()
      if (data) setAthleteId(data.id)
    }
    fetchAthleteId()
  }, [])

  const handleBlockClick = (blockId) => {
    if (blockId === 'badges') setPage('achievement')
    if (blockId === 'today') setPage('input')
    if (blockId === 'profile') setPage('profile')
    if (blockId === 'progress') setPage('analysis')
  }

  if (page === 'achievement') {
    return <AchievementPage profile={profile} athleteId={athleteId} onBack={() => setPage('dashboard')} />
  }

  if (page === 'profile') {
    return <AthleteProfile profile={profile} onBack={() => setPage('dashboard')} />
  }
  if (page === 'analysis') {
    return (
      <AnalysisPage
        profile={profile}
        athleteId={athleteId}
        onBack={() => setPage('dashboard')}
      />
    )
  }
  if (page === 'input') {
    return (
      <SessionInput
        profile={profile}
        athleteId={athleteId}
        onSuccess={() => setPage('dashboard')}
        onCancel={() => setPage('dashboard')}
      />
    )
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0f172a',
      color: '#f1f5f9'
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '1rem 1.5rem',
        borderBottom: '1px solid #1e293b'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <img
            src="/logo_rollaco.png"
            alt="Rollaco"
            style={{ width: '48px', height: '48px', objectFit: 'contain' }}
          />
          <div>
            <div style={{
              color: '#38bdf8',
              fontWeight: 'bold',
              fontSize: '1rem',
              letterSpacing: '0.05em'
            }}>
              ROLLACO
            </div>
            <div style={{
              color: '#94a3b8',
              fontSize: '0.7rem',
              letterSpacing: '0.1em'
            }}>
              CYCLING ACADEMY
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          {/* 🔔 Notification Bell */}
          <NotificationBell userId={profile?.id} />

          <div style={{ textAlign: 'right' }}>
            <div
              onClick={() => setPage('profile')}
              style={{
                color: '#f1f5f9',
                fontSize: '0.9rem',
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              {profile?.full_name} ⚙️
            </div>
            <div style={{
              color: '#38bdf8',
              fontSize: '0.75rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}>
              Atlet
            </div>
          </div>
          <button
            onClick={() => supabase.auth.signOut()}
            style={{
              background: '#1e293b',
              border: '1px solid #334155',
              borderRadius: '8px',
              color: '#94a3b8',
              padding: '0.4rem 0.75rem',
              cursor: 'pointer',
              fontSize: '0.8rem'
            }}
          >
            Keluar
          </button>
        </div>
      </div>

      {/* Greeting */}
      <div style={{ padding: '1.5rem 1.5rem 0.5rem' }}>
        <h2 style={{
          color: '#f1f5f9',
          fontSize: '1.3rem',
          fontWeight: 'bold',
          margin: 0
        }}>
          Hei, {profile?.full_name?.split(' ')[0]} 👋
        </h2>
        <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginTop: '0.25rem' }}>
          Klik blok <span style={{ color: '#38bdf8' }}>Sesi Hari Ini</span> untuk input latihan!
        </p>
      </div>

      {/* Treemap Dashboard */}
      <Treemap profile={profile} onBlockClick={handleBlockClick} />
    </div>
  )
}